<div class="main-content">
  <div class="container-fluid">

    <div *ngIf="loading" class="text-center" style="margin-top: 40px">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>

    <div *ngIf="!loading">
      <div class="admin-page-header">
        <div>
          <h3>My Applications</h3>
          <p class="text-muted">Manage your active applications and apply for available services.</p>
        </div>
      </div>

      <!-- EPE view -->
      <div *ngIf="auth.isEpe()" class="epe-applications">
        <div class="epe-application-col">
          <app-application-card
            [applications]="getApplications('epe')"
            [applicationType]="'epe'"
            [cardTitle]="APPLICATION_METADATA['epe'].title"
            [cardDescription]="APPLICATION_METADATA['epe'].description"
            [allowMultiple]="false"
            (applyClicked)="onApply($event)"
            (viewClicked)="onView($event)"
            (editClicked)="onEdit($event)">
          </app-application-card>
        </div>
      </div>

      <!-- Project view -->
      <div *ngIf="auth.isProject()" class="project-applications">
        <div class="project-application-col" *ngFor="let type of PROJECT_TYPES">
          <app-application-card
            [applications]="getApplications(type)"
            [applicationType]="type"
            [cardTitle]="APPLICATION_METADATA[type].title"
            [cardDescription]="APPLICATION_METADATA[type].description"
            [allowMultiple]="true"
            (applyClicked)="onApply($event)"
            (viewClicked)="onView($event)"
            (editClicked)="onEdit($event)">
          </app-application-card>
        </div>
      </div>
    </div>

  </div>
</div>
